/**
 * Type conversion helpers for filter components.
 *
 * Filter UI components expect string props (for form inputs),
 * but state/SSR data uses numbers. These helpers formalize
 * the conversion at the component boundary.
 */

/**
 * Converts a number to a string for filter component props.
 * Coalesces undef/null to null.
 */
export const toFilterString = (val: number | null | undefined): string | null =>
  val != null ? String(val) : null;

export const dollarToCentsString = (dollars: number | null | undefined): string | null =>
  dollars != null ? String(dollars * 100) : null;
